import Scene from "~/scene";

interface IPanoAtCoords {
	lon: number;
	lat: number;
	zoom?: number;
	selYear?: number;
	newRadius?: boolean;
}

interface IOpenPanoramaAt extends IPanoAtCoords {
	yaw?: number | string;
}

interface IPanoAtCoordsConf {
	nopenalties?: boolean;
	year?: number;
}

interface IGetPanoByPid {
	pid: number;
}

const NO_PENALTIES_ZOOM = 17;
const DEF_RADIUS = 50;
const PANORAMA_RADIUS_RANGE = [20, 500];
const PANORAMA_RADIUS_ZOOM = [7, 15];
const TIMELINE_RANGE_RADIUS = [100, 6];
const TIMELINE_RANGE_ZOOM = [14, 20];
const ZOOM_RANGES: Array<{ zoom: Array<number>; radius: (zoom: number) => number; }> = [{
	zoom: [19, 20],
	radius: () => 5,
}, {
	zoom: [16, 18],
	radius: () => 10,
}, {
	zoom: PANORAMA_RADIUS_ZOOM,
	radius: zoom => {
		const range = PANORAMA_RADIUS_RANGE[1] - PANORAMA_RADIUS_RANGE[0];
		const zoomDist = PANORAMA_RADIUS_ZOOM[1] - PANORAMA_RADIUS_ZOOM[0];

		// 15 20m
		// 2 500
		return PANORAMA_RADIUS_RANGE[1] - ((zoom - PANORAMA_RADIUS_ZOOM[0]) * (range / zoomDist));
	},
}, {
	zoom: [2, 6],
	radius: () => PANORAMA_RADIUS_RANGE[1],
}];


export function getPanoAtCoords({
	lon,
	lat,
	zoom,
	selYear = 0,
	newRadius = false,
}: IPanoAtCoords): Promise<any> {
	return new Promise((resolve, reject) => {
		const coords = Scene.coordsFromWGS84(lon, lat);
		const opts: IPanoAtCoordsConf = {};
		let radius = DEF_RADIUS;

		if (newRadius) {
			if (zoom) {
				if (zoom >= NO_PENALTIES_ZOOM) {
					opts.nopenalties = true;
				}

				radius = ZOOM_RANGES.filter(zoomItem => zoom >= zoomItem.zoom[0] && zoom <= zoomItem.zoom[1])[0].radius(zoom);
			}

			if (selYear) {
				opts.year = selYear;
			}
		} else {
			if (zoom) {
				if (zoom >= NO_PENALTIES_ZOOM) {
					opts.nopenalties = true;
				}

				radius = Math.round(Math.pow(2, Math.max(0, 12 - zoom)) * 100);
			}

			if (selYear && zoom) {
				opts.year = selYear;
				// [100, 84, 68, 53, 37, 21, 6], mozna zkusit [100, 75, 50, 35, 20, 10, 6]
				radius = zoom < TIMELINE_RANGE_ZOOM[0]
					? TIMELINE_RANGE_RADIUS[0]
					: Math.floor(((1 - ((zoom - TIMELINE_RANGE_ZOOM[0]) / (TIMELINE_RANGE_ZOOM[1] - TIMELINE_RANGE_ZOOM[0]))) * (TIMELINE_RANGE_RADIUS[0] - TIMELINE_RANGE_RADIUS[1])) + TIMELINE_RANGE_RADIUS[1]);
			}
		}

		SMap.Pano.getBest(coords, radius, opts).then(place => resolve(place), () => reject({}));
	});
}

export function getPanoByPid({
	pid,
}: IGetPanoByPid): Promise<any> {
	return new Promise((resolve, reject) => {
		SMap.Pano.get(pid).then(place => resolve(place), () => reject({}));
	});
}

export function openPanoramaAt({
	lon,
	lat,
	zoom,
	selYear = 0,
	yaw = 0,
}: IOpenPanoramaAt) {
	return new Promise((resolve, reject) => {
		getPanoAtCoords({
			lon,
			lat,
			zoom,
			selYear,
		}).then(place => {
			const panoState: any = {
				pid: place.getId(),
			};

			if (yaw) {
				panoState.yaw = typeof yaw === "number" ? yaw.toFixed(3) : yaw;
			}

			Mapy.getComponent("pano").activate().setState(panoState);
			resolve({});
		}, () => {
			const pano = Mapy.getComponent("pano");
			const state = pano.getState();

			pano.activate().setState(state);
			reject({});
		});
	});
}

export function glContext(canvas: HTMLCanvasElement, options?: WebGLContextAttributes): WebGLRenderingContext {
	const ctx = canvas.getContext("webgl", options) || canvas.getContext("experimental-webgl", options);

	if (!ctx) {
		throw new Error("WebGL not supported");
	}

	return ctx as WebGLRenderingContext;
}


export function isPanoSupported() {
	const canvas = document.createElement("canvas");

	try {
		glContext(canvas);

		return true;
	} catch (exc) {
		return false;
	}
}
